document.addEventListener('DOMContentLoaded', () => {
	const counters = document.querySelectorAll('.number');

	if (!counters.length) return;

	const countUp = (el) => {
		const raw = el.dataset.number || '';

		// Keep ONLY a leading "$" as prefix
		const prefix = raw.trim().startsWith('$') ? '$' : '';

		// Numeric target
		const target = parseInt(raw.replace(/[^\d]/g, ''), 10);

		const suffix = raw.replace(/^\$/, '').replace(/[\d,]/g, '');

		// Set animation duration
		const duration = 1200;
		const steps = 40;
		const increment = Math.max(Math.ceil(target / steps), 1);
		let count = 0;

		const interval = setInterval(() => {
			count += increment;

			// Stop animation at target number
			if (count >= target) {
				count = target;
				clearInterval(interval);
			}
			el.textContent = prefix + count.toLocaleString() + suffix;
		}, duration / steps);
	};

	// Animates only when element is fully visible
	const observer = new IntersectionObserver((entries, obs) => {
		entries.forEach(entry => {
			if (entry.isIntersecting) {
				countUp(entry.target);
				obs.unobserve(entry.target);
			}
		});
	}, { threshold: 1.0 });

	counters.forEach(el => observer.observe(el));
});
